var _ = require('./lodash-requires')
module.exports = require('./core')(_, global.Promise)



//////////////////
// WEBPACK FOOTER
// ./node_modules/checkit/index.js
// module id = 775
// module chunks = 7